import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fieldInput, fieldLabel, btnPrimary, btnGhost } from "@/admin/ui";

const EMPTY = { starts_at: "", duration_minutes: 120, format: "online", location: "", capacity: 14, price_huf: 12000, registration_open: false };

export default function SessionDialog({ open, onOpenChange, session, onSave, saving }) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (open) setForm(session ? { ...EMPTY, ...session } : EMPTY);
  }, [open, session]);

  const set = (key, num) => (e) => {
    const v = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm((f) => ({ ...f, [key]: num ? (v === "" ? "" : Number(v)) : v }));
  };

  const submit = (e) => {
    e.preventDefault();
    const { starts_at, duration_minutes, format, location, capacity, price_huf, registration_open } = form;
    onSave({ starts_at, duration_minutes, format, location, capacity, price_huf, registration_open });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-none bg-warm" data-testid="session-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-[28px] font-normal">{session ? "Időpont szerkesztése" : "Új időpont"}</DialogTitle>
          <DialogDescription className="font-body text-[13.5px]">Az időpont mentése nem küld e-mailt senkinek.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4" data-testid="session-form">
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2 sm:col-span-1">
              <label className={fieldLabel} htmlFor="sf-start">Dátum és kezdés</label>
              <input id="sf-start" type="datetime-local" required value={form.starts_at} onChange={set("starts_at")} data-testid="session-form-start" className={fieldInput} />
            </div>
            <div className="col-span-2 sm:col-span-1">
              <label className={fieldLabel} htmlFor="sf-duration">Időtartam (perc)</label>
              <input id="sf-duration" type="number" min={15} required value={form.duration_minutes} onChange={set("duration_minutes", true)} data-testid="session-form-duration" className={fieldInput} />
            </div>
            <div className="col-span-2 sm:col-span-1">
              <label className={fieldLabel} htmlFor="sf-format">Forma</label>
              <select id="sf-format" value={form.format} onChange={set("format")} data-testid="session-form-format" className={fieldInput}>
                <option value="online">Online</option>
                <option value="personal">Személyes</option>
              </select>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <label className={fieldLabel} htmlFor="sf-capacity">Maximális létszám (fő)</label>
              <input id="sf-capacity" type="number" min={1} required value={form.capacity} onChange={set("capacity", true)} data-testid="session-form-capacity" className={fieldInput} />
            </div>
            {form.format === "personal" && (
              <div className="col-span-2">
                <label className={fieldLabel} htmlFor="sf-location">Helyszín</label>
                <input id="sf-location" value={form.location} onChange={set("location")} data-testid="session-form-location" className={fieldInput} />
              </div>
            )}
            <div className="col-span-2 sm:col-span-1">
              <label className={fieldLabel} htmlFor="sf-price">Részvételi díj (Ft / fő)</label>
              <input id="sf-price" type="number" min={0} required value={form.price_huf} onChange={set("price_huf", true)} data-testid="session-form-price" className={fieldInput} />
            </div>
            <label className="col-span-2 sm:col-span-1 flex items-center gap-3 cursor-pointer font-body text-[14px] text-graphite sm:pt-6" data-testid="session-form-open">
              <input type="checkbox" checked={form.registration_open} onChange={set("registration_open")} className="accent-gold" />
              Jelentkezés nyitva
            </label>
          </div>
          <div className="flex justify-end gap-3 pt-3">
            <button type="button" onClick={() => onOpenChange(false)} className={btnGhost} data-testid="session-form-cancel">Mégse</button>
            <button type="submit" disabled={saving} className={btnPrimary} data-testid="session-form-save">{saving ? "Mentés…" : "Időpont mentése"}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
